import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomDropdownComponent } from './custom-dropdown.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [CustomDropdownComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [CustomDropdownComponent]
})
export class CustomDropdownModule { }
